import { DadosAdicionaisComissoes } from "app/types/comissoes/DadosAdiconais";
import React, { useState } from "react";
import { InputNumerico } from "./../../../inputs/InputNumerico";
import globalMU from "globalMU";
import { InputData } from "app/components/inputs/InputData";

const estiloAbaDadosAdiconais = require("./aba-dados-adiconais.module.scss").default;

export type AbaDadosAdicionaisProps = {
  dadosAdicionais: DadosAdicionaisComissoes[];
};

export const AbaDadosAdicionais = (props: AbaDadosAdicionaisProps) => {
  const [dadosAdionais, setDadosAdionais] = useState(props.dadosAdicionais);

  const handleChange = (valorModificado: number | string, value: DadosAdicionaisComissoes) => {
    dadosAdionais.forEach((dado) =>
      dado.Descricao == value.Descricao
        ? (dado.Valor = valorModificado)
        : null
    );
    const index = dadosAdionais.findIndex((dado) => dado.Descricao == value.Descricao);
    setDadosAdionais(
      dadosAdionais
        .slice(0, index)
        .concat(dadosAdionais[index])
        .concat(dadosAdionais.slice(index + 1, dadosAdionais.length))
    );
  };

  return (
    <>
      <div>
        <div className={` ${estiloAbaDadosAdiconais.formularioAbaDadosAdicionais}`}>
          {dadosAdionais?.map((value) => (
            <>
              <label>{value.Descricao}</label>
              {value.Tipo.NomeInterno === "NUMERICO" && (
                <InputNumerico
                  valor={Number(value.Valor)}
                  onValorModificado={(valorModificado) =>
                    handleChange(valorModificado, value)
                  } 
                  numeroCasasDecimais={2}
                />
              )}
              {value.Tipo.NomeInterno === "DATAHORARIO" && (
                <InputData
                  id="AbaDadosAdiconais_Data_Input"
                  className={estiloAbaDadosAdiconais.input}
                  data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(value.Valor as string)}
                  onChange={(e) => {
                    handleChange(e, value)
                  }}
                  selecionaValorOnFocus
                />
              )}
              {value.Tipo.NomeInterno === "TEXTOLONGO" && (
                <textarea
                  rows={4}
                  cols={50}
                  onChange={(e) => handleChange(e.target.value, value)}
                />
              )}
              {value.Tipo.NomeInterno != "NUMERICO" &&
                value.Tipo.NomeInterno != "TEXTOLONGO" &&
                value.Tipo.NomeInterno != "DATAHORARIO" && (
                  <input
                    value={(value.Valor) ?? ""}
                    onChange={(e) => handleChange(e.target.value, value)}
                    className={estiloAbaDadosAdiconais.input}
                  />
                )}
            </>
          ))}
        </div>
      </div>
    </>
  );
};


